import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  asurite: '',
  role: '',
  college: '',
  department: '',
  details: '',
  sendAllEmails: 'N',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserAll: (state, action) => {
      state.asurite = action.payload.asurite;
      state.role = action.payload.role;
      state.college = action.payload.college;
      state.department = action.payload.department;
      state.details = action.payload.details;
      state.sendAllEmails = action.payload.sendAllEmails;

      return state;
    },
    setSendAllEmails: (state, action) => {
      state.sendAllEmails = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserAll, setSendAllEmails } = userSlice.actions;

export default userSlice.reducer;
